export const mascararCodigoInstituicaoDeEnsino = (value) => {
  return value.replace(/\D/g, '');
};
